import LocationList from "./list";


if (document.body.getAttribute("data-current-path") === "locations") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new LocationList();
    }
}